import { connect } from 'react-redux'
import DriverViewSessionHistoryOld from '../../components/drivers/DriverViewSessionHistoryOld'
import { IStoreState } from '../../types/index'
import DriverViewSchedule, { IDriverViewScheduleProps } from 'src/components/drivers/DriverViewSchedule'

const mapStateToProps = (state: IStoreState, props: any) => {
  const operatorId = props.operatorId
  const currentOperator = state.drivers.items[operatorId]
  return {
    operatorId: props.operatorId,
    orgId: state.organizations.currentOrgId,
    currentOperator
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverViewSchedule)



// WEBPACK FOOTER //
// ./src/containers/drivers/DriverViewSchedule.ts